module.exports = __webpack_public_path__ + "img/denied-with-conditions.3263f67a.svg";